//statuses
export const PAYEE_ORDER_STATUS_CREATED = 'CREATED'
export const PAYEE_ORDER_STATUS_PAID = 'PAID'
export const PAYEE_ORDER_STATUS_SEEN = 'SEEN'
export const PAYEE_ORDER_STATUS_READY_FOR_PICKUP = 'READY FOR PICKUP'
export const PAYEE_ORDER_STATUS_PICKED_UP = 'PICKED UP'
export const PAYEE_ORDER_STATUS_COMPLETED = 'COMPLETED'
export const PAYEE_ORDER_STATUS_CANCELLED = 'CANCELLED'

//fulfillment methods
export const FULFILLMENT_METHOD_PICKUP = "pickup"
export const FULFILLMENT_METHOD_DELIVERY = "delivery"